{
  "tabs": {
    "chat": "채팅",
    "reminders": "알림",
    "calendar": "캘린더",
    "settings": "설정"
  },
  "common": {
    "cancel": "취소",
    "save": "저장",
    "confirm": "확인",
    "delete": "삭제",
    "back": "뒤로",
    "close": "닫기",
    "edit": "편집",
    "search": "검색",
    "all": "전체",
    "loading": "로딩 중...",
    "error": "문제가 발생했습니다",
    "notFound": "찾을 수 없음",
    "tryAgain": "다시 시도해 주세요",
    "retry": "재시도",
    "undo": "실행 취소",
    "pullToRefresh": "당겨서 새로고침",
    "justNow": "방금"
  },
  "auth": {
    "welcome": "FishMemory에 오신 것을 환영합니다",
    "tagline": "당신의 WhatsApp 알림 도우미, 이제 주머니 속에 있습니다.",
    "subtitle": "당신의 WhatsApp 알림 도우미, 이제 주머니 속에 있습니다.",
    "phoneLabel": "당신의 WhatsApp 번호",
    "phoneHint": "WhatsApp으로 인증 코드를 보냅니다",
    "invalidPhone": "유효한 전화번호를 입력해 주세요",
    "continue": "계속",
    "enterPhone": "WhatsApp 번호를 입력하세요",
    "phonePlaceholder": "전화번호",
    "sendCode": "코드 보내기",
    "verifyTitle": "번호 인증",
    "otpSentTo": "{{phone}}로 6자리 코드가 WhatsApp을 통해 전송되었습니다",
    "enterFullCode": "6자리 모두 입력해 주세요",
    "invalidOtp": "잘못된 코드입니다. 다시 시도해 주세요.",
    "otpFailed": "코드 전송 실패. 다시 시도해 주세요.",
    "otpResent": "코드 재전송됨",
    "resendIn": "{{seconds}}초 후 재전송",
    "resendCode": "코드 재전송",
    "enterOtp": "WhatsApp으로 받은 코드를 입력하세요",
    "verify": "인증",
    "resend": "코드 재전송",
    "wrongNumber": "번호가 잘못됐나요?",
    "backToPhone": "전화번호로 돌아가기",
    "editPhone": "전화번호 수정",
    "error": "오류",
    "setupTitle": "설정을 시작해 볼까요",
    "setupSubtitle": "나중에 설정에서 언제든 변경할 수 있습니다",
    "namePlaceholder": "이름을 입력하세요",
    "letsGo": "설정 완료",
    "skipForNow": "나중에 하기"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "메시지를 입력하세요...",
    "inputPlaceholder": "메시지를 입력하세요...",
    "typing": "FishMemory가 입력 중입니다...",
    "online": "온라인",
    "connecting": "연결 중...",
    "reconnecting": "재연결 중...",
    "offline": "오프라인",
    "empty": "대화를 시작하세요",
    "emptyHint": "알림 생성, 일정 확인, 도움 요청이 가능합니다.",
    "emptyAction": "샘플 알림 보내기",
    "actions": "채팅 작업",
    "keep": "메시지 유지",
    "clearTitle": "채팅 삭제",
    "clearConfirm": "이 기기에서 모든 메시지를 삭제하시겠습니까? 복구할 수 없습니다.",
    "clear": "채팅 삭제",
    "optionSelected": "선택됨: {{label}}",
    "sendingSelection": "전송 중...",
    "connectionLost": "재연결 중..."
  },
  "reminders": {
    "title": "내 알림",
    "active": "활성",
    "today": "오늘",
    "thisWeek": "이번 주",
    "history": "기록",
    "items": "개",
    "emptyTitle": "아직 알림이 없습니다",
    "emptySubtitle": "채팅에서 생성하면 여기에 표시됩니다.",
    "emptyAction": "채팅 열기",
    "filterActive": "활성",
    "filterToday": "오늘",
    "filterWeek": "이번 주",
    "filterHistory": "기록",
    "emptyState": "아직 알림이 없습니다. 채팅을 시작하세요!",
    "swipeDone": "완료",
    "swipeSnooze": "미루기",
    "swipeDelete": "삭제",
    "search": "알림 검색...",
    "upcoming": "예정",
    "completed": "완료됨",
    "overdue": "지남",
    "tomorrow": "내일",
    "synced": "동기화됨 {{value}}",
    "swipeHint": "알림을 스와이프하여 추가 작업",
    "noResults": "검색 결과가 없습니다",
    "noResultsHint": "다른 키워드를 시도하거나 검색을 지우세요",
    "deleteAllFailed": "모든 알림 삭제 실패"
  },
  "calendar": {
    "title": "캘린더",
    "today": "오늘",
    "tomorrow": "내일",
    "completed": "완료",
    "noEvents": "일정 없음",
    "noEventsSubtitle": "날짜를 선택해 알림과 일정을 확인하세요.",
    "googleEvent": "Google Calendar",
    "legendActive": "활성",
    "legendRecurring": "반복",
    "legendDone": "완료",
    "legendGoogle": "Google",
    "previousMonth": "이전 달",
    "nextMonth": "다음 달",
    "previousYear": "이전 년",
    "nextYear": "다음 년",
    "goToToday": "오늘로 이동",
    "all": "전체",
    "active": "활성",
    "done": "완료",
    "paused": "일시중지"
  },
  "settings": {
    "title": "설정",
    "profile": "프로필",
    "name": "표시 이름",
    "enterName": "이름을 입력하세요",
    "language": "언어",
    "uiLanguage": "앱 언어",
    "uiLanguageHelp": "이 기기에서 앱 UI, 캘린더 레이블, 레이아웃 방향을 변경합니다.",
    "serverLanguage": "채팅 언어",
    "serverLanguageHelp": "계정의 서버 응답 및 알림 메시지 언어를 변경합니다.",
    "timezone": "시간대",
    "currentTimezone": "현재 시간대",
    "timezoneHelp": "모든 알림 시간이 이 시간대로 표시됩니다.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "시간대 저장",
    "timezoneSaved": "시간대가 업데이트되었습니다",
    "detect": "감지",
    "detectFailed": "시간대 감지 실패",
    "autoDetect": "GPS로 자동 감지",
    "notifications": "알림",
    "notificationsHelp": "후속 알림은 알림 전달 후 반복 알림을 제어합니다. 기기 알림 권한은 휴대폰 설정에서 관리합니다.",
    "pushEnabled": "푸시 알림",
    "autoDoneOnFire": "알림 시 자동 완료 표시",
    "autoDoneOnFireDesc": "꺼짐 시, 완료 표시할 때까지 알림이 활성 상태로 유지됩니다.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "연결됨",
    "googleDisconnected": "연결 안 됨",
    "googleConnectedHelp": "새 알림을 자동으로 캘린더에 동기화할 수 있습니다.",
    "googleDisconnectedHelp": "Google Calendar를 연결해 알림과 일정을 맞추세요.",
    "googleConnectFailed": "Google Calendar 연결 실패",
    "connected": "연결됨",
    "disconnected": "연결 안 됨",
    "connect": "연결",
    "disconnect": "연결 해제",
    "autoSync": "새 알림 자동 동기화",
    "autosync": "새 알림 자동 동기화",
    "subscription": "구독",
    "trialUsed": "체험: {{used}}/{{total}} 사용됨",
    "trialStatus": "체험 가능",
    "activeStatus": "구독 활성",
    "expiredStatus": "구독 만료",
    "unsubscribedStatus": "구독 안 함",
    "about": "정보",
    "version": "버전",
    "logout": "로그아웃",
    "logoutTitle": "로그아웃",
    "logoutConfirm": "정말 로그아웃 하시겠습니까?",
    "noName": "이름 없음",
    "serverConnection": "서버 연결",
    "serverUrl": "서버 URL",
    "serverEdit": "수정",
    "saveReconnect": "저장 후 재연결",
    "resetDefault": "기본값으로 재설정",
    "invalidServerUrlTitle": "잘못된 서버 URL",
    "invalidServerUrlMessage": "예: https://example.com 같은 유효한 http 또는 https 서버 URL을 입력하세요",
    "uiLanguageChangeFailed": "앱 언어 변경 실패. 다시 시도해 주세요.",
    "serverLanguageChangeFailed": "채팅 언어 변경 실패. 다시 시도해 주세요.",
    "timezoneChangeFailed": "시간대 변경 실패. 다시 시도해 주세요.",
    "autoSyncChangeFailed": "자동 동기화 업데이트 실패. 다시 시도해 주세요.",
    "nameChangeFailed": "표시 이름 업데이트 실패. 다시 시도해 주세요.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "알림 세부사항",
    "editTime": "시간 편집",
    "rename": "이름 변경",
    "snooze": "미루기",
    "snooze15": "15분 미루기",
    "pause": "일시중지",
    "pauseReminder": "알림 일시중지",
    "resume": "재개",
    "resumeReminder": "알림 재개",
    "skip": "다음 건 건너뛰기",
    "skipOccurrence": "이번 건 건너뛰기",
    "syncGoogle": "Google에 동기화",
    "delete": "삭제",
    "deleteTitle": "알림 삭제",
    "deleteConfirm": "이 알림이 영구 삭제됩니다.",
    "deleteRecurringTitle": "반복 알림 삭제",
    "deleteRecurringMessage": "이번 건만 건너뛸까요, 아니면 전체 시리즈를 삭제할까요?",
    "deleteThisOccurrence": "이번 건 건너뛰기",
    "deleteEntireSeries": "전체 시리즈 삭제",
    "done": "완료",
    "markDone": "완료로 표시",
    "undo": "복원",
    "undoPrompt": "다시 활성화하려면 지금 복원하세요.",
    "recurring": "반복",
    "nextRun": "다음 실행",
    "oneTime": "일회성",
    "pending": "대기 중",
    "sent": "전송됨",
    "paused": "일시중지됨",
    "active": "활성",
    "snoozed": "미룸",
    "localTime": "현지 시간으로 표시",
    "recurrence": "반복 주기",
    "created": "생성됨",
    "tags": "태그",
    "fireCount": "알림 횟수",
    "actions": "작업",
    "none": "없음",
    "snoozeFailed": "알림 미루기 실패",
    "pauseFailed": "알림 일시중지 실패",
    "resumeFailed": "알림 재개 실패",
    "skipFailed": "알림 건너뛰기 실패",
    "doneFailed": "알림 완료 표시 실패",
    "undoFailed": "알림 상태 복원 실패",
    "deleteFailed": "알림 삭제 실패",
    "rescheduleTitle": "다시 일정 잡기?",
    "rescheduleMsg": "이 알림이 지났습니다. 다시 일정 잡으시겠습니까?",
    "reschedule15": "15분 후",
    "reschedule60": "1시간 후",
    "keepOverdue": "그대로 유지"
  },
  "onboarding": {
    "slide1Title": "FishMemory에 오신 것을 환영합니다",
    "slide1Sub": "WhatsApp 기반 개인 알림 도우미 — 주머니 속에 쏙 들어갑니다.",
    "slide2Title": "자연스럽게 채팅하세요",
    "slide2Sub": "\"내일 오후 3시에 엄마에게 전화하라고 알려줘\"처럼 생각하는 대로 입력하세요 — 나머지는 저희가 처리합니다.",
    "slide3Title": "중요한 걸 놓치지 마세요",
    "slide3Sub": "적시에 알림을 받고, 태그로 정리하며, 중요한 모든 것을 관리하세요.",
    "getStarted": "시작하기",
    "next": "다음",
    "firstReminderTitle": "첫 알림을 만들어 보세요!",
    "firstReminderHint": "다음과 같이 입력해 보세요:",
    "firstReminderExample": "내일 오전 9시에 물 마시라고 알려줘",
    "gotIt": "알겠어요!",
    "notifRationaleTitle": "시간을 놓치지 마세요",
    "notifRationaleBody": "FishMemory는 제때 알림을 보내기 위해 알림 권한이 필요합니다. 생성한 알림에 대해서만 알림을 받습니다.",
    "notifRationaleAllow": "알림 허용",
    "notifRationaleLater": "나중에",
    "swipeHint": "빠른 작업은 오른쪽으로 스와이프 →",
    "calendarDragHint": "드래그하여 확장 ↕"
  }
}
